var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 219,
    height: 73,
    viewBox: "0 0 219 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_365",
    x: 0,
    y: 0,
    width: 219,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40064",
    "data-name": "Group 40064",
    transform: "translate(-945.001 -550)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40057",
    "data-name": "Group 40057",
    transform: "translate(101 85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BTn_Primary",
    transform: "translate(853.2 470.654)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.2, -5.65)",
    filter: "url(#Rectangle_365)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365-2",
    "data-name": "Rectangle 365",
    width: 201,
    height: 55,
    rx: 8,
    transform: "translate(9 6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Amazon_Web_Services_Logo_1_",
    "data-name": "Amazon_Web_Services_Logo (1)",
    transform: "translate(868.332 485.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80950",
    "data-name": "Path 80950",
    d: "M24.544,10.533a4.371,4.371,0,0,0,.159,1.286,7.733,7.733,0,0,0,.462,1.04.628.628,0,0,1,.1.332.572.572,0,0,1-.274.433l-.91.607a.693.693,0,0,1-.376.13.665.665,0,0,1-.433-.2,4.469,4.469,0,0,1-.52-.679c-.144-.246-.289-.52-.448-.852a5.337,5.337,0,0,1-4.247,1.994,3.958,3.958,0,0,1-2.889-1.04A3.711,3.711,0,0,1,14.1,10.808a3.719,3.719,0,0,1,1.315-2.976,5.255,5.255,0,0,1,3.539-1.127,11.438,11.438,0,0,1,1.531.116c.535.072,1.083.188,1.661.318V6.084a3.2,3.2,0,0,0-.679-2.311,3.325,3.325,0,0,0-2.355-.665,6.573,6.573,0,0,0-1.56.188,11.511,11.511,0,0,0-1.56.491,4.145,4.145,0,0,1-.506.188.886.886,0,0,1-.231.043c-.2,0-.3-.144-.3-.448V2.862a.914.914,0,0,1,.1-.506,1.082,1.082,0,0,1,.4-.3,8.317,8.317,0,0,1,1.82-.65,8.758,8.758,0,0,1,2.254-.274A5.279,5.279,0,0,1,23.317,2.3a4.781,4.781,0,0,1,1.2,3.554v4.681Zm-5.865,2.2a4.682,4.682,0,0,0,1.488-.26,3.219,3.219,0,0,0,1.372-.925,2.293,2.293,0,0,0,.491-.925,5.186,5.186,0,0,0,.144-1.257V8.756a12.064,12.064,0,0,0-1.329-.246,10.885,10.885,0,0,0-1.358-.087A3.33,3.33,0,0,0,17.336,9a2.013,2.013,0,0,0-.708,1.661,1.864,1.864,0,0,0,2.051,2.066Zm11.6,1.56a.806.806,0,0,1-.549-.144,1.177,1.177,0,0,1-.3-.563L26.032,2.415a2.53,2.53,0,0,1-.13-.578.317.317,0,0,1,.347-.361h1.416a.8.8,0,0,1,.563.144,1.182,1.182,0,0,1,.289.563l2.427,9.563L33.2,2.183a1.013,1.013,0,0,1,.274-.563.994.994,0,0,1,.578-.144h1.156a.869.869,0,0,1,.578.144.973.973,0,0,1,.274.563l2.282,9.679,2.5-9.679a1.239,1.239,0,0,1,.289-.563.943.943,0,0,1,.563-.144h1.343a.321.321,0,0,1,.361.361,1.44,1.44,0,0,1-.029.231,2.056,2.056,0,0,1-.1.361L39.785,13.6a1.108,1.108,0,0,1-.3.563.924.924,0,0,1-.549.144H37.69a.869.869,0,0,1-.578-.144,1.024,1.024,0,0,1-.274-.578L34.6,4.264l-2.225,9.3a1.128,1.128,0,0,1-.274.578.9.9,0,0,1-.578.144Zm18.563.39a9.56,9.56,0,0,1-2.225-.26,6.572,6.572,0,0,1-1.661-.578,1.041,1.041,0,0,1-.448-.4,1.02,1.02,0,0,1-.087-.4V12.3c0-.3.116-.448.332-.448a.818.818,0,0,1,.26.043c.087.029.217.087.361.144a7.858,7.858,0,0,0,1.589.506,8.675,8.675,0,0,0,1.719.173,3.9,3.9,0,0,0,2.109-.477,1.556,1.556,0,0,0,.751-1.372,1.407,1.407,0,0,0-.39-1.011A3.625,3.625,0,0,0,49.7,9.1L47.6,8.453A4.406,4.406,0,0,1,45.289,6.98a3.442,3.442,0,0,1-.722-2.095,3.215,3.215,0,0,1,.39-1.6A3.714,3.714,0,0,1,46,2.1a4.585,4.585,0,0,1,1.5-.751,6.3,6.3,0,0,1,1.82-.246,7.252,7.252,0,0,1,.968.058c.332.043.636.1.939.159s.563.144.823.231a3.153,3.153,0,0,1,.607.26,1.249,1.249,0,0,1,.433.361.778.778,0,0,1,.13.477v.679c0,.3-.116.462-.332.462a1.5,1.5,0,0,1-.549-.173,6.609,6.609,0,0,0-2.774-.563,3.729,3.729,0,0,0-1.921.4,1.4,1.4,0,0,0-.679,1.286A1.364,1.364,0,0,0,47.4,5.766a4.315,4.315,0,0,0,1.589.795l2.051.65A4.394,4.394,0,0,1,53.278,8.6a3.269,3.269,0,0,1,.665,2.022,3.714,3.714,0,0,1-.376,1.676,3.885,3.885,0,0,1-1.055,1.271,4.657,4.657,0,0,1-1.6.809A6.869,6.869,0,0,1,48.843,14.679Z",
    transform: "translate(-10.636)",
    fill: "#252f3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40055",
    "data-name": "Group 40055",
    transform: "translate(1.668 17.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80951",
    "data-name": "Path 80951",
    d: "M40.937,122.69c-4.753,3.51-11.658,5.374-17.6,5.374A31.832,31.832,0,0,1,1.86,119.873c-.448-.4-.043-.953.491-.636a42.664,42.664,0,0,0,37.892,2.355C41.038,121.231,41.717,122.113,40.937,122.69Z",
    transform: "translate(-1.668 -118.283)",
    fill: "#f90",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80952",
    "data-name": "Path 80952",
    d: "M251.94,115.346c-.607-.78-4.016-.376-5.562-.188-.462.058-.535-.347-.116-.65,2.716-1.907,7.18-1.358,7.7-.722s-.144,5.114-2.687,7.252c-.39.332-.766.159-.592-.274C251.261,119.333,252.547,116.111,251.94,115.346Z",
    transform: "translate(-210.692 -113.192)",
    fill: "#f90",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40056",
    "data-name": "Group 40056",
    transform: "translate(747.491 624.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M409.185-129.379v-2.413a.6.6,0,0,1,.613-.611h10.81a.6.6,0,0,1,.623.609v2.069a3.4,3.4,0,0,1-.814,1.518l-5.6,7.995a11.982,11.982,0,0,1,6.165,1.323,1.106,1.106,0,0,1,.575.941v2.575c0,.355-.388.765-.8.552a12.454,12.454,0,0,0-11.423.02c-.376.2-.769-.2-.769-.558v-2.446a2.919,2.919,0,0,1,.4-1.658l6.488-9.306h-5.648a.6.6,0,0,1-.625-.607",
    transform: "translate(-168.516 -1.314)",
    fill: "#100f0d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M251.436-115.173h-3.29a.62.62,0,0,1-.588-.557l0-16.88a.62.62,0,0,1,.634-.608l3.063,0a.624.624,0,0,1,.6.567v2.206h.061a4.336,4.336,0,0,1,4.328-3.125c2.057,0,3.346.993,4.267,3.125a4.669,4.669,0,0,1,4.545-3.125,4.664,4.664,0,0,1,3.8,1.845c1.044,1.422.829,3.48.829,5.293l0,10.652a.621.621,0,0,1-.634.608h-3.285a.618.618,0,0,1-.591-.607v-8.949a21.658,21.658,0,0,0-.092-3.161,1.714,1.714,0,0,0-1.934-1.455,2.183,2.183,0,0,0-1.966,1.383,10.228,10.228,0,0,0-.306,3.233v8.948a.621.621,0,0,1-.634.608h-3.285a.618.618,0,0,1-.59-.607l0-8.949c0-1.883.308-4.652-2.025-4.652-2.364,0-2.272,2.7-2.272,4.652l0,8.948a.62.62,0,0,1-.634.608",
    transform: "translate(-50.198 -0.457)",
    fill: "#100f0d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M470.946-130.127c-2.427,0-2.579,3.3-2.579,5.364s-.03,6.464,2.549,6.464c2.548,0,2.671-3.552,2.671-5.718a15.61,15.61,0,0,0-.491-4.475A2.061,2.061,0,0,0,470.946-130.127Zm-.03-3.444c4.881,0,7.521,4.191,7.521,9.517,0,5.151-2.918,9.237-7.521,9.237-4.79,0-7.4-4.192-7.4-9.413,0-5.257,2.64-9.34,7.4-9.34",
    transform: "translate(-208.893 -0.457)",
    fill: "#100f0d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M532.934-115.173h-3.277a.618.618,0,0,1-.59-.607l0-16.887a.622.622,0,0,1,.63-.55l3.052,0a.626.626,0,0,1,.584.473v2.583h.062c.92-2.309,2.21-3.409,4.481-3.409a4.31,4.31,0,0,1,3.838,1.988c.859,1.349.859,3.622.859,5.256V-115.7a.623.623,0,0,1-.628.532h-3.3a.623.623,0,0,1-.586-.532v-9.166c0-1.847.215-4.547-2.057-4.547a2.154,2.154,0,0,0-1.9,1.35,7.493,7.493,0,0,0-.522,3.2v9.09a.63.63,0,0,1-.64.608",
    transform: "translate(-257.06 -0.457)",
    fill: "#100f0d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M354.855-115.672a.682.682,0,0,1-.776.077,8.04,8.04,0,0,1-1.885-2.192,6.518,6.518,0,0,1-5.421,2.39c-2.77,0-4.923-1.709-4.923-5.126a5.587,5.587,0,0,1,3.507-5.375,22.763,22.763,0,0,1,6.184-1.14v-.427a4.206,4.206,0,0,0-.4-2.385,2.194,2.194,0,0,0-1.846-.854,2.505,2.505,0,0,0-2.644,1.975.692.692,0,0,1-.571.6l-3.187-.345a.577.577,0,0,1-.491-.687c.732-3.868,4.225-5.037,7.354-5.037a7.464,7.464,0,0,1,4.953,1.637c1.6,1.5,1.445,3.489,1.445,5.66v5.124a4.489,4.489,0,0,0,1.243,3.048.622.622,0,0,1-.012.874c-.672.563-1.865,1.6-2.521,2.184Zm-3.315-8.02a6.449,6.449,0,0,1-.616,3.489,2.671,2.671,0,0,1-2.277,1.5c-1.26,0-2-.961-2-2.385,0-2.8,2.513-3.31,4.891-3.31v.711",
    transform: "translate(-119.487 0)",
    fill: "#100f0d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M192.256-115.672a.684.684,0,0,1-.778.077,8.052,8.052,0,0,1-1.885-2.192,6.517,6.517,0,0,1-5.422,2.39c-2.769,0-4.923-1.709-4.923-5.126a5.588,5.588,0,0,1,3.508-5.375,22.766,22.766,0,0,1,6.184-1.14v-.427a4.206,4.206,0,0,0-.4-2.385,2.2,2.2,0,0,0-1.845-.854,2.5,2.5,0,0,0-2.644,1.975.694.694,0,0,1-.571.6l-3.188-.345a.578.578,0,0,1-.491-.687c.732-3.868,4.225-5.037,7.354-5.037a7.463,7.463,0,0,1,4.954,1.637c1.6,1.5,1.445,3.489,1.445,5.66v5.124a4.5,4.5,0,0,0,1.242,3.048.622.622,0,0,1-.01.874c-.672.563-1.866,1.6-2.522,2.184Zm-3.316-8.02a6.461,6.461,0,0,1-.615,3.489,2.671,2.671,0,0,1-2.276,1.5c-1.263,0-2-.961-2-2.385,0-2.8,2.512-3.31,4.892-3.31v.711",
    transform: "translate(0 0)",
    fill: "#100f0d",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsLogin);
export default __webpack_public_path__ + "static/media/AwsLogin.02394d7747340d7c58802c6542c0bb71.svg";
export { ForwardRef as ReactComponent };